import { useEffect, useState } from 'react'
import { VStack } from '@chakra-ui/react'
import { useAtom } from 'jotai'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { CircularProgressModal, ConfirmPopupModal } from '@!/components/Modal'
import { purchaseCoinWithCarrierApi, purchaseCoinWithPaypayApi } from '@!/Api/coinPurchase'
import { isBlank } from '@!/Util'
import { listIndexAtom, cardInfoAtom, apiTimeAtom, accessIdAtom, accessTokenAtom, payStartUrlAtom, payTypeAtom } from '@!/atoms/paymentAtom'
import { PageBackLink, PaymentHeader, PaymentMethodList } from '@!/User/Payment/components'
import { usePaymentValidation } from '@!/User/Payment/Hooks/usePaymentValidation'

export const PaymentSelect = () => {
  usePaymentValidation()

  const navigate = useNavigate()
  const [listIndex] = useAtom(listIndexAtom)
  const [cardInfo] = useAtom(cardInfoAtom)
  const [apiTime] = useAtom(apiTimeAtom)
  const [accessId, setAccessId] = useAtom(accessIdAtom)
  const [accessToken, setAccessToken] = useAtom(accessTokenAtom)
  const [, setPayStartUrl] = useAtom(payStartUrlAtom)
  const [, setPayType] = useAtom(payTypeAtom)

  const [isProcessing, setIsProcessing] = useState(false)
  const [apiError, setApiError] = useState(null)

  // キャリア決済API
  const execPurchaseCarrierMutation = useMutation({
    mutationFn: (params) => purchaseCoinWithCarrierApi(params),
    onSuccess: (data) => {
      setAccessId(data.access_id)
      setAccessToken(data.token)
      setPayStartUrl(data.start_url)
      setIsProcessing(false)
    },
    onError: (error) => {
      if (error.data?.error) {
        setApiError(error.data.error)
      } else {
        setApiError('etc_error')
      }
      setIsProcessing(false)
    },
  })

  // PayPay決済API
  const execPurchasePaypayMutation = useMutation({
    mutationFn: (params) => purchaseCoinWithPaypayApi(params),
    onSuccess: (data) => {
      setAccessId(data.access_id)
      setAccessToken(data.token)
      setPayStartUrl(data.start_url)
      setIsProcessing(false)
    },
    onError: (error) => {
      if (error.data?.error) {
        setApiError(error.data.error)
      } else {
        setApiError('etc_error')
      }
      setIsProcessing(false)
    },
  })

  const handlePurchase = (payType) => {
    if (isProcessing) return

    setPayType(payType)

    if (payType === 'paypay') {
      execPurchasePaypayMutation.mutate({ listIndex: listIndex, apiTime: apiTime })
    } else {
      execPurchaseCarrierMutation.mutate({ listIndex: listIndex, apiTime: apiTime, carrier: payType })
    }
  }

  useEffect(() => {
    if (isProcessing || !accessId || !accessToken || apiError) {
      return
    }

    navigate('/redirect')
  }, [isProcessing, accessId, accessToken, apiError])

  const pageBack = (e) => {
    e.preventDefault()
    navigate(-1)
  }

  const handleDialog = () => {
    navigate(-1)
  }

  const creditCardLink = isBlank(cardInfo) ? '/new_card' : '/confirm'

  return (
    <VStack maxW="600px" m="auto">
      <PaymentHeader />
      <PageBackLink pageBack={pageBack} />
      <PaymentMethodList creditCardLink={creditCardLink} handlePurchase={handlePurchase} />
      <CircularProgressModal isOpen={isProcessing} />
      <ConfirmPopupModal handlePopup={() => handleDialog()} text="エラーが発生しました。" isOpen={!!apiError} />
    </VStack>
  )
}

export default PaymentSelect
